import React, { forwardRef } from 'react';

const TableHeader = forwardRef(function TableHeader({ children, ...props }, ref) {
  return (
    <thead ref={ref} {...props}>{children}</thead>
  );
});

TableHeader.tableSection = 'thead';
export default TableHeader;
